import { createTracker } from 'usage-tracker';
import events from 'productupdates-ui/events.yaml';
import { withSessionReplay } from 'usage-tracker-session-replay';
const oldTracker = createTracker({
  events
});
export const oldUsageTracker = withSessionReplay(oldTracker, {
  sampleRate: 0.1
});
const tracker = createTracker({
  standalone: true
});
export default withSessionReplay(tracker, {
  sampleRate: 0.1
});